import { LazyAction, LazyModule, preloadScriptChunk } from 'owa-bundling';
preloadScriptChunk('OptOutDialog');
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "OptOutDialog" */ './lazyIndex');
});
export var lazyShowOptOutDialog = new LazyAction(lazyModule, function (m) { return m.showOptOutDialog; });
//# sourceMappingURL=index.js.map